<template>
</template>

<script>
import auth from "@/utils/auth.js";

export default {
  created() {
    this.init()
  },
  methods: {
    async init() {
      // 处理url
      this.urlHandler()
      // 获取用户信息
      await this.getLoginUser()
      // 页面跳转
      this.jupHandler()

    },
    getLoginUser() {
      return new Promise((resolve, reject) => {
        this.httpUtil.ajax({
          url: "getLoginUser.json"
        }).then(data => {
          localStorage.setItem("username", data.returndata.username);
          localStorage.setItem("userid", data.returndata.userid);
          localStorage.setItem("roleids", data.returndata.roleids);
          localStorage.setItem("servers", data.returndata.servers);
          resolve()
        }).catch(err => {
          console.error(err);
          reject(err)
        })

      })
    },
    urlHandler() {
      let url = window.location.href;
      //拿到token
      let authorization = url.substring(url.indexOf("authorization=") + 14, url.indexOf("&idToken"));
      //拿到注销url
      let outUrl = url.substring(url.indexOf("&outUrl") + 8);
      // debugger
      //注销url编译了的.需要反编译,注意注销重新下url不需要反编译
      outUrl = decodeURIComponent(outUrl.substring(0, outUrl.indexOf("post_logout_redirect_uri%3D") + 27)) + outUrl.substring(outUrl.indexOf("post_logout_redirect_uri%3D") + 27);

      auth.setToken(authorization)
      localStorage.setItem("token", authorization);
      localStorage.setItem("outUrl", outUrl);
    },
    jupHandler() {
      const origin = localStorage.getItem('origin')
      window.location.href = origin + '/main';
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/frame/sso.vue